'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RegressionTypeSelect = undefined;

var _Style = require('./Style');

var _Style2 = _interopRequireDefault(_Style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegressionTypeSelect = function RegressionTypeSelect(refs) {
    var i18n = refs.i18nManager.get();

    return Ext.create('Ext.form.field.ComboBox', {
        cls: 'ns-combo',
        style: 'margin-bottom:' + _Style2.default.comboBottomMargin + 'px',
        width: _Style2.default.cmpWidth,
        labelWidth: _Style2.default.labelWidth,
        fieldLabel: i18n.trend_line,
        labelSeparator: null,
        labelStyle: 'color:#333',
        queryMode: 'local',
        valueField: 'id',
        editable: false,
        value: 'NONE',
        store: Ext.create('Ext.data.Store', {
            fields: ['id', 'text'],
            data: [{ id: 'NONE', text: i18n.none }, { id: 'LINEAR', text: i18n.linear }, { id: 'POLYNOMIAL', text: i18n.polynomial }, { id: 'LOESS', text: i18n.loess }]
        })
    });
};

exports.RegressionTypeSelect = RegressionTypeSelect;
exports.default = RegressionTypeSelect;
//# sourceMappingURL=RegressionType.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/options/RegressionType.js
 ** module id = 358
 ** module chunks = 0
 **/